import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "payments";
// initial state
const state = () => ({
  all: [],
  payments: [],
  payment: {},
  supplierPayment: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getPayment: (state) => {
    return state.payment;
  },

  getSupplierPayment: (state) => state.supplierPayment,

  getPayments: (state) => {
    return state.payments;
  },

  getTotalAmount: (state) =>
    state.payments.reduce((acc, val) => acc + parseFloat(val.amount), 0),
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let payments = response.data;
      commit("SET_PAYMENTS", payments);
      window.location;
    });
  },

  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let payment = response.data;
      commit("setPayment", payment);
    });
  },

  async showPaymentSupplier({ commit }, reference) {
    await this.$api.show(api + "_suppliers/" + reference).then((response) => {
      let payment = response.data;
      commit("setSupplierPayment", payment);
    });
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-customers-index" });
      }
    });
  },

  async update({ dispatch }, data) {
    await axios.put(api + "/" + data.reference, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "payments-customers-index",
        });
      }
    });
  },

  async destroy({ dispatch }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-customers-index" });
      }
    });
  },

  async destroyPaymentSupplier({ dispatch }, reference) {
    await this.$api.delete(api + "_suppliers/" + reference).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-suppliers-index" });
      }
    });
  },

  async filter({ dispatch, commit }, data) {
    await axios.post(api + "_filter", data).then((response) => {
      let payments = response.data;
      commit("SET_PAYMENTS", payments);
    });
  },

  async print({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "La liste des paiements du client est en cours de téléchargement. Veuillez patienter...",
        },
        { root: true }
      );
      const response = await axios
        .post(api + "_print", data, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Paiements.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async printReceipt({ dispatch }, reference) {
    await printData(
      { reference },
      api + "_print_receipt/" + reference,
      "POST",
      null,
      null
    );
  },

  async printPaymentSupplierReceipt({ dispatch }, reference) {
    await printData(
      { reference },
      api + "_suppliers_print_receipt/" + reference,
      "POST",
      null,
      null
    );
  },

  async fetchPaymentSupplier({ commit }) {
    await axios.get(api + "_suppliers").then((response) => {
      let payments = response.data;
      commit("SET_PAYMENTS", payments);
      window.location;
    });
  },

  async storePaymentSupplier({ dispatch }, data) {
    await this.$api.create(api + "_suppliers", data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({
          name: "payments-suppliers-index",
        });
      }
    });
  },
};

// mutations
const mutations = {
  SET_PAYMENTS(state, payments) {
    state.all = payments;
    state.payments = payments;
  },
  setPayment(state, payment) {
    state.payment = payment;
  },
  async setSupplierPayment(state, value) {
    state.supplierPayment = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
